<script setup>
useCustomMeta('pref', '沖縄')
const route = useRoute()
const breadCrumbList = getBreadCrumb('okinawa')
const { data: mapPosition } = await useFetch('/api/wind/mapConfig', { query: { path: 'okinawa' } })
if (route.path !== `/okinawa/`) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :area="getAreaPrefectureName('okinawa')"
      area-roma="okinawa"
    >
      <div class="frame">
        <WindMap
          :map-position="mapPosition"
          :title="getAreaPrefectureName('okinawa')"
          pref-en="okinawa"
        />
      </div>
      <template #main-bottom>
        <WindCityList pref="okinawa" />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
